const accessMarketplace = {

    CROP_LISTING_LIST: {
        path: '/crop-listing-list'
    },

    MARKETPLACE_VIEW: {
        path: '/marketplace-view'
    },

}

export default accessMarketplace;